import { useEffect } from 'react';
import usePaymentMethods from '@/hooks/usePaymentMethods';
import PaymentMethodsDropdown from '@/components/Customers/CustomersPage/PaymentMethodsDropdown/PaymentMethodsDropdown';

type PaymentMethodsColumnProps = {
  accountID: string;
  disabled: boolean;
  email: string;
  name: string;
};

export default function PaymentMethodsColumn({ accountID, disabled, email, name }: PaymentMethodsColumnProps) {
  const { fetching, methods, fetchMethods, setDefaultMethod } = usePaymentMethods({
    accountID,
    currencies: ['CAD'],
  });

  useEffect(() => {
    fetchMethods();
  }, []);

  return (
    <PaymentMethodsDropdown
      methods={methods}
      setDefaultMethod={setDefaultMethod}
      fetching={fetching}
      disabled={disabled}
      triggerSize="small"
      accountName={name}
      accountID={accountID}
      email={email}
    />
  );
}
